import { Injectable } from '@angular/core';
import { FantasyGameService } from './fantasy-game.service';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({ providedIn: 'root' })
export class FantasyGameResolver {
  constructor(
    private fantasyService: FantasyGameService,
    private loggingService: LoggingService
  ) {}

  resolve() {
    this.loggingService.info('resolving fantasy games');
    return this.fantasyService.fetchFantasyGamesV2(10, false, true);
  }
}
